import { Col, DesignTokens, Row } from "melco-ui";
import { ProductionFilesCard } from "./ProductionFilesCard";

const { spacings } = DesignTokens;

export type StatisticsCardRowProps = {
  startTimestamp?: Date;
  endTimestamp?: Date;
};

export const StatisticsCardRow: React.FC<StatisticsCardRowProps> = ({
  startTimestamp,
  endTimestamp,
}) => (
  <Row gutter={[spacings.middle, spacings.middle]}>
    <Col span={24}>
      <ProductionFilesCard
        startTimestamp={startTimestamp}
        endTimestamp={endTimestamp}
      />
    </Col>
  </Row>
);
